import {
  MERCH_LIST_REQUEST,
  MERCH_LIST_SUCCESS,
  MERCH_LIST_FAIL,
  MERCH_ADD_REQUEST,
  MERCH_ADD_SUCCESS,
  MERCH_ADD_FAIL,
  MERCH_ADD_RESET,
  MERCH_DETAILS_REQUEST,
  MERCH_DETAILS_SUCCESS,
  MERCH_DETAILS_FAIL,
} from "../Constants/MerchConstants";

// Merchandise list reducer
export const merchListReducer = (state = { merch: [] }, action) => {
  switch (action.type) {
    case MERCH_LIST_REQUEST:
      return { loading: true, merch: [] };
    case MERCH_LIST_SUCCESS:
      return { loading: false, merch: action.payload };
    case MERCH_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Merchandise details reducer
export const merchDetailsReducer = (state = { merch: {} }, action) => {
  switch (action.type) {
    case MERCH_DETAILS_REQUEST:
      return { loading: true, ...state };
    case MERCH_DETAILS_SUCCESS:
      return { loading: false, merch: action.payload };
    case MERCH_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Merchandise add reducer
export const merchAddReducer = (state = {}, action) => {
  switch (action.type) {
    case MERCH_ADD_REQUEST:
      return { loading: true };
    case MERCH_ADD_SUCCESS:
      return { loading: false, success: true, merch: action.payload };
    case MERCH_ADD_FAIL:
      return { loading: false, error: action.payload };
    case MERCH_ADD_RESET:
      return {};
    default:
      return state;
  }
};